import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { NotificationStatusChangeResponse } from './interfaces/notification.interface'

interface PropsNotificationStatusChange {
    authToken: string
    notification_id?: string | null
    notifications_ids?: string | null
    status: number
}

/**
 * @description cambia el status de la notificacion al ser tocada
 * @param param0 
 * @returns 
 */
export const request_notification_status_change = async ({ authToken, notification_id, notifications_ids, status }: PropsNotificationStatusChange) => {
    const URL_NOTIFICATION_STATUS_CHANGE = apiUrl + '/oneapp/notification_status_change'

    try {

        let headers = {
            // 'Content-Type': 'application/json',
            Authorization: authToken,
            status: status.toString(),
        }

        if (notification_id) {
            headers['notification_id'] = notification_id
        }
    
        if (notifications_ids) {
            headers['notifications_ids'] = notifications_ids
        }

        const response = await fetch(URL_NOTIFICATION_STATUS_CHANGE, {
            method: 'POST',
            headers: headers,
        })

        if (response.ok) {
            const data: NotificationStatusChangeResponse = await response.json()
            return data
        } else {
            throw new Error('Error al realizar la solicitud notification_status_change')
        }
    } catch (error) {
    logError('NotificationService', 'notification_status_change failed', error)
    }
}
